'use client';

import React, { useMemo } from 'react';
import Select, { Option } from './CustomSelect';
import Icon from './Icon';
import { Button } from './Button';

export type PaginationProps = {
  totalItems: number;
  page?: number;
  limit?: number;
  onChange?: (paginationData: { page: number; limit: number }) => void;
};
/**
 * Pagination component
 */
const Pagination: React.FC<PaginationProps> = ({ page = 1, totalItems, limit = 20, onChange }) => {
  const totalPage = useMemo(() => {
    return Math.ceil(totalItems / limit);
  }, [limit, totalItems]);

  if (totalItems <= limit && totalItems < 20) {
    return null;
  }

  return (
    <div className="flex w-full">
      <div className="flex gap-6 items-center py-2.5 pr-3 pl-1 justify-between border-t border-border w-full">
        <div className="flex gap-2 items-center">
          <Button
            data-testid="pagination-prev"
            variant="ghost"
            disabled={page <= 1}
            className="w-8 h-8 disabled:bg-transparent px-0"
            onClick={() => {
              if (onChange) {
                onChange({ page: page - 1, limit });
              }
            }}
          >
            <Icon name="chevron-right" className="w-5 h-5 rotate-180" />
          </Button>

          <p className="text-sm text-muted-foreground">{`Page ${page} of ${totalPage}`}</p>

          <Button
            data-testid="pagination-next"
            disabled={page >= totalPage}
            variant="ghost"
            className="w-8 h-8 disabled:bg-transparent px-0"
            onClick={() => {
              if (onChange) {
                onChange({ page: page + 1, limit });
              }
            }}
          >
            <Icon name="chevron-right" className="w-5 h-5" />
          </Button>
        </div>

        <div className="flex gap-4 items-center">
          <Select
            triggerClassNames="h-8"
            defaultValue={`${limit}`}
            onOptionSelect={value => {
              const limit = Number((value as Option)?.id);
              // setLimit(limit);
              if (onChange) {
                onChange({ page: 1, limit });
              }
            }}
            options={[
              {
                id: '10',
                value: '10 / page',
              },
              {
                id: '20',
                value: '20 / page',
              },
              {
                id: '50',
                value: '50 / page',
              },
              {
                id: '100',
                value: '100 / page',
              },
            ]}
          />
        </div>
      </div>
    </div>
  );
};
export default Pagination;
